//import firebase from 'firebase'
import {db, storage} from '@/firebase';
import {codigoNegocioTotem} from '@/utils/funciones_auxiliares.js'

export default {
  
}